module.exports = __webpack_public_path__ + "static/media/edit-prescription.01923745.svg";